<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Dépôt
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des dépôts</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: search + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher"
               style="padding: 0.375rem 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; font-size: 0.875rem; outline: none;">
      </div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Auteur</th>
            <th>Référence</th>
            <th>Canal</th>
            <th>Montant</th>
            <th>Transféré</th>
            <th>Status</th>
            <th>Date dépôt/transfert</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)" type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
            <td>{{d.reference}}</td>
            <td>{{d.tool}}</td>
            <td>{{d.amount}}</td>
            <td>{{d.transferred ? 'Oui':'Non'}}</td>
            <td><app-status [value]="d.status"></app-status></td>
            <td>{{ d.transferred ? d.transferred_at : d.created_at | date:"dd/MM/yyyy hh:mm:ss"}}</td>
          </tr>

          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="8" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Ajouter le pourcentage des frais de transfert</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Pourcentage <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="value" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Le pays de validité (S'il est défini sur vide, il sera valable dans tous les pays) <span class="text-danger ml-2">(*)</span></label>
          <select name="country" class="afri-input" ngModel>
            <option *ngFor="let c of countries" [value]="c.code">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier un rôle</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Libellé <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" [(ngModel)]="selected_data.name">
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless align-middle mb-0">
        <tbody></tbody>
      </table>
    </div>
  </div>
</ng-template>
